import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { deleteAdminUser } from '@actions/adminUsers/deleteAdminUser';
import {
    getAdminUserIsPosting,
    getAdminUserPostSuccess,
    getAdminUsersPostError,
} from '@selectors/adminUsers';

export default function useDeleteAdmin(userID: number): UseDeleteAdminReturn {
    const dispatch = useDispatch();

    const deleteUser = useCallback(() => {
        dispatch(deleteAdminUser(userID));
    }, [dispatch, userID]);

    const isPosting = useSelector(getAdminUserIsPosting);
    const error = useSelector(getAdminUsersPostError);
    const deleteSuccess = useSelector(getAdminUserPostSuccess);

    return {
        deleteUser,
        isPosting,
        error,
        deleteSuccess,
    };
}

interface UseDeleteAdminReturn {
    deleteUser: () => void;
    isPosting: boolean;
    error: string | null;
    deleteSuccess: boolean;
}
